import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import CommentList from '../../components/Posts/CommentList';
import LikeList from '../../components/Posts/LikeList';
import PostDetails from '../../components/Posts/PostDetails';
import Dashboard from '../../components/Dashboard';
import {
  getPostDetail,
  getPostComments,
  deleteComment,
  getPostLikes
} from '../../redux/modules/post/action';

const ROWS_PER_PAGE = 10;

class ViewPost extends React.Component {
  state = {
    page: 0,
    rowsPerPage: ROWS_PER_PAGE,
    likePage: 0
  };

  async componentDidMount() {
    const { dispatch, match } = this.props;
    const { rowsPerPage, page, likePage } = this.state;

    await dispatch(getPostDetail(match.params.postId));
    await dispatch(getPostComments(match.params.postId, page, rowsPerPage));
    await dispatch(getPostLikes(match.params.postId, likePage, rowsPerPage));
  }

  handleChangePage = (event, page) => {
    const { dispatch, match } = this.props;
    const { rowsPerPage } = this.state;
    this.setState({ page });
    dispatch(getPostComments(match.params.postId, page, rowsPerPage));
  };

  handleChangeRowsPerPage = event => {
    const { dispatch, match } = this.props;
    const { page } = this.state;
    this.setState({ rowsPerPage: event.target.value });
    dispatch(getPostComments(match.params.postId, page, event.target.value));
  };

  handleChangeLikePage = (event, page) => {
    const { dispatch, match } = this.props;
    const { rowsPerPage } = this.state;
    this.setState({ likePage: page });
    dispatch(getPostComments(match.params.postId, page, rowsPerPage));
  };

  handleChangeLikeRowsPerPage = event => {
    const { dispatch, match } = this.props;
    const { likePage } = this.state;
    this.setState({ rowsPerPage: event.target.value });
    dispatch(getPostComments(match.params.postId, likePage, event.target.value));
  };

  removeComment = (commentId) => {
    const { dispatch, match } = this.props;
    const postId = match.params.postId;

    dispatch(deleteComment(postId, commentId));
  }

  render() {
    const {
      postDetails,
    } = this.props;

    const { rowsPerPage, page, likePage } = this.state;

    return (
      <Dashboard>
        <PostDetails
          postDetails={postDetails}
        />
        <CommentList
          list={postDetails.comments && postDetails.comments.rows}
          total={postDetails.comments && postDetails.comments.count}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          rowsPerPage={rowsPerPage}
          page={page}
          removeComment={this.removeComment}
        />
        <LikeList 
          list={postDetails.likes && postDetails.likes.rows}
          totalRecords={postDetails.likes && postDetails.likes.count}
          handleChangePage={this.handleChangeLikePage}
          handleChangeRowsPerPage={this.handleChangeLikeRowsPerPage}
          rowsPerPage={rowsPerPage}
          page={likePage}
        />
      </Dashboard>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    postDetails: state.post.details,
    message: state.user.message
  }
}

ViewPost.propTypes = {
  initialValues: PropTypes.object,
  isVerified: PropTypes.bool,
  isActive: PropTypes.bool,
}

ViewPost.defaultProps = {
  isVerified: false,
  isActive: false
}

export default connect(mapStateToProps)(ViewPost);
